import { ReactNode, useState } from "react";
import { SingleOrderContext } from "./SingleOrderContext";
import { Mode } from "./SingleOrderContext.types";
import React from "react";
export const SingleOrderContextProvider: React.FC<{
  children: ReactNode;
  disableReadMode: boolean;
  global_actions?: boolean;
  orderId?: any;
  patchUrl?: string;
  dataType?: string;
  itemModelId?: number;
}> = ({ children, disableReadMode, global_actions = false, orderId, patchUrl, dataType, itemModelId }) => {
  const defaultMode = disableReadMode ? "edit" : "read";

  const [mode, setMode] = useState<Mode>(defaultMode);

  return (
    <SingleOrderContext.Provider value={{ mode, setMode, global_actions, orderId, patchUrl, dataType, itemModelId }}>
      {children}
    </SingleOrderContext.Provider>
  );
};
